import React, { useState, useRef } from 'react';
import { Star, ChevronLeft, ChevronRight } from 'lucide-react';
export function Testimonials() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const testimonials = [{
    name: 'Michael R.',
    text: 'Absolutely incredible service! They came to my office and my Tesla looked brand new. Worth every penny for the convenience alone.',
    rating: 5
  }, {
    name: 'Sarah K.',
    text: 'Best detailing in Phoenix, hands down. The waterless process is amazing — no mess, perfect results. My SUV has never looked better.',
    rating: 5
  }, {
    name: 'David M.',
    text: 'Used them for my RV and boat. Professional, thorough, and the ceramic coating has held up beautifully against the sun.',
    rating: 5
  }, {
    name: 'Jennifer L.',
    text: "Prompt, professional, and meticulous. The detailer spent 4 hours on my car and didn't miss a spot. Highly recommended!",
    rating: 5
  }];
  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const {
        current
      } = scrollRef;
      const scrollAmount = direction === 'left' ? -300 : 300;
      current.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-20 md:py-32 bg-[#F5F5F5]" data-id="element-239">
      <div className="container mx-auto px-4 md:px-6" data-id="element-240">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-8 md:mb-12 gap-4" data-id="element-241">
          <div data-id="element-242">
            <h2 className="text-3xl md:text-5xl font-black text-[#111111] uppercase mb-2" data-id="element-243">
              What Our Customers Say
            </h2>
            <div className="w-24 h-1 bg-[#7FD4D4]" data-id="element-244"></div>
          </div>

          <div className="flex gap-2" data-id="element-245">
            <button onClick={() => scroll('left')} className="p-3 md:p-3 min-w-[44px] min-h-[44px] border border-gray-300 rounded-full hover:bg-[#7FD4D4] hover:border-[#7FD4D4] hover:text-white transition-colors flex items-center justify-center" aria-label="Previous testimonial" data-id="element-246">
              <ChevronLeft size={20} data-id="element-247" />
            </button>
            <button onClick={() => scroll('right')} className="p-3 md:p-3 min-w-[44px] min-h-[44px] border border-gray-300 rounded-full hover:bg-[#7FD4D4] hover:border-[#7FD4D4] hover:text-white transition-colors flex items-center justify-center" aria-label="Next testimonial" data-id="element-248">
              <ChevronRight size={20} data-id="element-249" />
            </button>
          </div>
        </div>

        <div className="md:hidden text-center mb-4" data-id="element-250">
          <p className="text-sm text-gray-500 flex items-center justify-center" data-id="element-251">
            <span className="mr-2" data-id="element-252">←</span>
            Swipe to see more reviews
            <span className="ml-2" data-id="element-253">→</span>
          </p>
        </div>

        <div ref={scrollRef} className="flex overflow-x-auto gap-6 pb-8 scrollbar-hide snap-x snap-mandatory" data-id="element-254">
          {testimonials.map((review, index) => <div key={index} className="min-w-[280px] md:min-w-[400px] bg-white p-6 md:p-8 rounded-sm shadow-lg border border-gray-100 snap-center flex flex-col" data-id="element-255">
              <div className="flex text-[#FFD700] mb-4" data-id="element-256">
                {[...Array(review.rating)].map((_, i) => <Star key={i} size={18} fill="#FFD700" data-id="element-257" />)}
              </div>
              <p className="text-gray-600 italic mb-6 flex-1 text-base md:text-lg" data-id="element-258">
                "{review.text}"
              </p>
              <div className="flex items-center justify-between mt-auto" data-id="element-259">
                <span className="font-bold text-gray-900 font-montserrat" data-id="element-260">
                  {review.name}
                </span>
                <div className="flex items-center text-xs font-medium text-gray-500" data-id="element-261">
                  <span className="w-4 h-4 rounded-full bg-gradient-to-tr from-blue-500 to-red-500 mr-2 flex items-center justify-center text-white text-[8px]" data-id="element-262">
                    G
                  </span>
                  Google Review
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}